export default __webpack_public_path__ + "static/rsz_13logo-kopia-9a09a953d1df565f739d2a2467e8baa6.png";